/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="modal-header">\n  ';
 if (data.title) { ;
__p += '\n  	<h1>' +
((__t = ( data.title )) == null ? '' : __t) +
'</h1>\n  ';
 } else if (data.alertType == 'confirm') { ;
__p += '\n  	<h1>Are you sure?</h1>\n  ';
 } ;
__p += '\n</div>\n\n<div class="modal-body">\n  ' +
((__t = ( data.body )) == null ? '' : __t) +
'\n</div>\n\n<div class="modal-footer">\n  ';
 if (data.alertType === 'confirm') { ;
__p += '\n    <div class="cancel cancel-button" aria-hidden="true">' +
__e(data.cancelText) +
'</div>\n  ';
 } ;
__p += '\n    <div type="button" class="ok main-modal-button" aria-hidden="true">' +
__e(data.okText) +
'</div>\n    <div class="clear"></div>\n</div>\n\n';
return __p
}
